import { UserForm } from "components/users";
import { useQueryUser } from "hooks/users";
import { useParams } from "react-router-dom";

export const EditUser = () => {
  const { uid } = useParams();

  const { isLoading, isError, error, user } = useQueryUser({
    uid: uid!,
  });

  if (isLoading) {
    return null;
  }
  if (isError) {
    return (
      <div>
        Something went wrong:
        {error?.message}
      </div>
    );
  }

  return <UserForm user={user} />;
};
